import styled from 'styled-components'

import { CurrencyModel } from '@root/entities/currency'
import { MarkerCapShortFormatted } from '@root/shared/core/format'

import type { CurrencyModel as CurrencyModelType } from '@root/entities/currency'
import type { BigNumber } from 'bignumber.js'

type Props = {
  currency: CurrencyModelType
  marketCapUsd: BigNumber
}

export const WalletAssetsMarketCapCell: React.FC<Props> = ({
  currency,
  marketCapUsd,
}) => {
  if (CurrencyModel.isNative(currency)) {
    return undefined
  }

  return (
    <Root>
      <MarkerCapShortFormatted mcap={marketCapUsd} />
    </Root>
  )
}

const Root = styled.div`
  color: var(--text-7);
  text-align: start;

  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`
